module.exports = {
  footerText: 'Vi ricordiamo che tutte le informazioni contenute nella piattaforma, incluso ogni documento ivi caricato o allegato, sono di carattere confidenziale e sono destinate ad uso esclusivo dei soggetti in possesso di apposite credenziali di accesso. E’ vietata qualsivoglia divulgazione, riproduzione o distribuzione del suo contenuto.',
}
